module.exports = __webpack_public_path__ + "static/media/UnionPay.4f1430ae.svg";